module.exports = __webpack_public_path__ + "static/logo-c90e30a85a419792e41b2ddb17a491e5.png";